import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import { IPage } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/IPage";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { Person } from "@/models/crunchbase/Person";
import { Funder, FunderType } from "@/types/FunderTypes";
import { LazoFileType } from "@/types/LazoFileType";

class FunderService {
  path: string;

  constructor(path: string) {
    this.path = path;
  }

  searchByEntityName(name: string, funderListExternalId: string): Promise<ApiResponseV2<Funder[]>> {
    return HttpClientV2.get(`${this.path}/search?name=${name}&funderListExternalId=${funderListExternalId}`, {
      axiosConfig: { timeout: 1800000 },
    });
  }

  searchByInvestorName(name: string): Promise<ApiResponseV2<Funder[]>> {
    return HttpClientV2.get(`${this.path}/search/investor?name=${name}`, {
      axiosConfig: { timeout: 1800000 },
    });
  }
  searchByOrganizationName(name: string): Promise<ApiResponseV2<Funder[]>> {
    return HttpClientV2.get(`${this.path}/search/organization?name=${name}`, {
      axiosConfig: { timeout: 1800000 },
    });
  }
  searchByPersonName(name: string): Promise<ApiResponseV2<Funder[]>> {
    return HttpClientV2.get(`${this.path}/search/person?name=${name}`, {
      axiosConfig: { timeout: 1800000 },
    });
  }

  getPeopleAssociatedOfOrganization(uuid: string, funderListExternalId?: string): Promise<ApiResponseV2<Funder<Person>[]>> {
    return HttpClientV2.get(`${this.path}/organization/${uuid}/people-associated?funderListExternalId=${funderListExternalId}`, {
      axiosConfig: { timeout: 1800000 },
    });
  }

  getAllPaginatedByFunderList(
    funderListExternalId: string,
    page: number = 0,
    pageSize: number = 50
  ): Promise<ApiResponseV2<IPage<Funder>>> {
    return HttpClientV2.get(`${this.path}/funder-list?funderListExternalId=${funderListExternalId}&page=${page}&pageSize=${pageSize}`);
  }

  uploadFunderImage(externalId: string, fileType: LazoFileType, funderType: FunderType, file: File): Promise<ApiResponseV2<string>> {
    const formData = new FormData();
    formData.append("file", file);
    return HttpClientV2.post(`${this.path}/${externalId}/${funderType}/upload/${fileType}`, formData, {
      axiosConfig: {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    });
  }
}

export default new FunderService("api/funder");
